import React from 'react';
import { Outlet, useLocation, useBeforeUnload } from 'react-router-dom';
import { useSearchCriteriaReadFacade } from 'redux/search-criteria-read/search-criteria-read.facade';

export function FpSearchGuard() {
  const { managementEnd } = useSearchCriteriaReadFacade();
  const location = useLocation();

  // Handle browser unload (refresh/close)
  useBeforeUnload(() => {
    if (location.pathname === '/search') {
      managementEnd();
    }
  });

  // Handle navigation away from /search
  React.useEffect(() => () => {
    if (location.pathname === '/search') {
      managementEnd();
    }
  }, [location.pathname, managementEnd]);

  return <Outlet />;
}
